import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async'; // VIP SEO Zırhımız eklendi
import { supabase } from '../supabase'; 

function Projeler() {
  const [projeler, setProjeler] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- EFSANEVİ SAYFALAMA (PAGINATION) MOTORU ---
  const [mevcutSayfa, setMevcutSayfa] = useState(1);
  const sayfaBasinaUrun = 24; // Her sayfada tam 6 proje gösterecek

  useEffect(() => {
    const projeleriGetir = async () => {
      try {
        const { data, error } = await supabase
          .from('projeler')
          .select('*')
          .order('olusturulma_tarihi', { ascending: false });

        if (error) throw error;
        
        setProjeler(data);
      } catch (error) {
        console.error("Resimler çekilirken hata oluştu dostum:", error.message);
      } finally {
        setLoading(false);
      }
    };

    projeleriGetir();
  }, []);

  // --- SİHİRLİ MATEMATİK: Sayfada gösterilecek 6 projeyi kesme ---
  const sonProjeIndex = mevcutSayfa * sayfaBasinaUrun;
  const ilkProjeIndex = sonProjeIndex - sayfaBasinaUrun;
  const gosterilecekProjeler = projeler.slice(ilkProjeIndex, sonProjeIndex);
  
  // Toplam sayfa sayısı hesabı
  const toplamSayfa = Math.ceil(projeler.length / sayfaBasinaUrun);

  // Sayfa değiştirildiğinde en yukarı yumuşakça kaydırma motoru
  const sayfaDegistir = (sayfaNumarasi) => {
    setMevcutSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // --- EFSANEVİ AKILLI SAYFALAMA MOTORU ---
  const getSayfaNumaralari = (mevcut, toplam) => {
    const delta = 1; 
    const range = [];
    for (let i = Math.max(2, mevcut - delta); i <= Math.min(toplam - 1, mevcut + delta); i++) {
      range.push(i);
    }
    if (mevcut - delta > 2) range.unshift("...");
    if (mevcut + delta < toplam - 1) range.push("...");
    range.unshift(1);
    if (toplam > 1) range.push(toplam);
    return range;
  };

  return (
    <div className="projeler-page">
      
      {/* İŞTE VIP GOOGLE KİMLİK KARTIMIZ BURADA DOSTUM */}
      <Helmet>
        <title>Tamamlanan Projeler & Referanslarımız | Demir Grup Ankara</title>
        <meta name="description" content="Demir Grup İnşaat ve Güvenlik Sistemleri olarak Ankara'da tamamladığımız fabrika, şantiye ve site güvenlik altyapı projelerimiz." />
        <link rel="canonical" href="https://www.ddemirgrup.com.tr/projeler" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Demir Grup Tamamlanan Projeler",
            "description": "Ankara ve çevresinde başarıyla teslim edilen güvenlik ve zayıf akım altyapı projeleri galerisi."
          })}
        </script>
      </Helmet>

      <div className="projeler-header">
        <h1>Tamamlanan Projelerimiz</h1>
        <p>Demir Grup güvencesiyle hayata geçirdiğimiz şantiye ve güvenlik operasyonlarımız.</p>
      </div>

      {loading ? (
        <div className="premium-loader-container">
          <div className="dg-spinner"></div>
          <div className="premium-loader-text">Projeler Yükleniyor...</div>
        </div>
      ) : projeler.length === 0 ? (
        <div className="empty-gallery" style={{textAlign: 'center', color: '#94a3b8', marginTop: '50px'}}>
          Henüz bir proje yüklenmemiş.
        </div>
      ) : (
        <>
          <div className="gallery-grid">
            {/* Sadece hesaplanan 6 projeyi basıyoruz! */}
            {gosterilecekProjeler.map((proje) => (
              <div key={proje.id} className="gallery-item">
                <img src={proje.resim_url} alt={proje.proje_adi} loading="lazy" />
                <div className="gallery-overlay">
                  <h3>{proje.proje_adi}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* --- LÜKS AKILLI SAYFALAMA BUTONLARI --- */}
          {toplamSayfa > 1 && (
            <div className="pagination-container">
              <button 
                onClick={() => sayfaDegistir(mevcutSayfa - 1)} 
                disabled={mevcutSayfa === 1}
                className="page-btn nav-btn"
              >
                &#10094;
              </button>
              
              {/* AKILLI SAYFALAMA BASIMI */}
              {getSayfaNumaralari(mevcutSayfa, toplamSayfa).map((sayfa, index) => (
                <button 
                  key={index} 
                  onClick={() => typeof sayfa === 'number' ? sayfaDegistir(sayfa) : null} 
                  className={`page-btn ${mevcutSayfa === sayfa ? 'active' : ''}`}
                  disabled={sayfa === '...'}
                  style={sayfa === '...' ? { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'default', boxShadow: 'none' } : {}}
                >
                  {sayfa}
                </button>
              ))}

              <button 
                onClick={() => sayfaDegistir(mevcutSayfa + 1)} 
                disabled={mevcutSayfa === toplamSayfa}
                className="page-btn nav-btn"
              >
                 &#10095;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Projeler;